'use client'

import { SellerPromotion } from '@marketplace-web/domain/welcome-image'

import useTabs from '../hooks/useTabs'
import { useHomeContext } from '../HomeProvider'

const HomeSellerPromotion = ({ visitsCount }: { visitsCount: number }) => {
  const { isLoading } = useHomeContext()
  const { currentTab } = useTabs()

  if (!currentTab.isSellerPromotionEnabled) return null
  if (isLoading) return null

  return <SellerPromotion visitsCount={visitsCount} />
}

export default HomeSellerPromotion
